/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

/* ------------------  Message Types ------------------ */

export type Message = {
  role: MessageRole;
  text: string;
};

export enum MessageRole {
  AI = "AI",
  Human = "Human",
  System = "System",
}

/* ------------------ Asset Types ------------------ */

export type Asset = ImageAsset | AIImageAsset | VideoAsset | QuoteAsset | SongAsset | OtherAsset;

export enum AssetType {
  AIImage = "AIImage",
  Image = "Image",
  Video = "Video",
  Quote = "Quote",
  Song = "Song",
  Other = "Other",
}

export type ImageAsset = {
  type: AssetType.Image;
  query: string;
  url: string;
};

export type AIImageAsset = {
  type: AssetType.AIImage;
  url: string;
  prompt: string;
};

export type VideoAsset = {
  type: AssetType.Video;
  title: string;
  url: string;
  soughtTitle: string;
};

export type SongAsset = {
  type: AssetType.Song;
  title: string;
  artist: string;
  url: string;
};

export type QuoteAsset = {
  type: AssetType.Quote;
  text: string;
};

export type OtherAsset = {
  type: AssetType.Other;
  title: string;
  url: string;
  summary: string;
};

export type AssetSummary = {
  sought: number;
  found: number;
  type: AssetType;
};

/* ------------------ Socket Types ------------------ */
export enum EmitType {
  Heartbeat = "heartbeat",
  RawData = "raw-data",
  Token = "token",
  Asset = "asset",
  ConfirmAction = "confirm-action",
  ConfirmActionResponse = "confirm-action-response",
}

export enum LogType {
  Step = "step",
  Message = "message",
  Action = "action-proposal",
  Success = "success",
  Info = "info",
  Failure = "failure",
}

export type LogSnapshot = {
  role: MessageRole;
  type: LogType;
  content: string;
  id: string;
};

/* -------------------------------------------------- */
/*                     Other Types                    */
/* -------------------------------------------------- */

export type UserInputContext = {
  // topic: string;
  previousMessages: Message[];
};

export enum JobStatus {
  Running = "Running",
  Success = "Job success",
  Canceled = "Job canceled",
  Failed = "Job failed",
  None = "No job",
}

export interface GenerateResponse {
  messages: Message[];
  summaries: AssetSummary[];
  status: JobStatus;
}
